import { ReactNode } from "react";
import { Grid, GridItem } from "@chakra-ui/react";
import Sidebar from "components/layout/Sidebar";
import { ChatProvider } from "providers/chat";
import { NotificationsProvider } from "providers/notifications";

function DashboardLayout({ children }: { children: ReactNode }) {
  return (
    <NotificationsProvider>
      <ChatProvider>
        <Grid
          templateAreas={`
						"nav main"
					`}
          gridTemplateRows="1fr"
          gridTemplateColumns="240px 1fr"
          height="100vh"
        >
          <GridItem
            area="nav"
            borderTopRightRadius="20px"
            boxShadow="0px 2px 8px 0px #00000014"
            bg="white"
          >
            <Sidebar />
          </GridItem>

          <GridItem area="main" p={4}>
            {children}
          </GridItem>
        </Grid>
      </ChatProvider>
    </NotificationsProvider>
  );
}

export default DashboardLayout;
